module.exports = __webpack_public_path__ + "static/media/tilepackage16.522e39f2.svg";